import { defineComponent } from "vue";
import VueCookie from 'vue-cookie'
import loginService from "@/services/login.service";
import http from "@/http-common";
import { useToast } from "vue-toastification";


export default defineComponent({
   name: "login",
   setup() {
      const toast = useToast();
      return { toast }
   },
   data() {
      return {
         loginData: {
            email: "",
            password: "",
         },
         url: '',
         incorrectCredentials: false,
         userDeactivated: false,
      };
   },
   mounted() {
      this.url = process.env.BASE_URL;
   },
   methods: {
      onSubmit() {
         this.userDeactivated = false;
         this.incorrectCredentials = false;
         const loader = this.$loading.show();
         loginService
            .login(this.loginData)
            .then((res) => {
               loader.hide();
               VueCookie.set("customer_token", res.token, {
                  expires: res.token_expiry,
               });
               VueCookie.set("name", res.customer_name, {
                  expires: res.token_expiry,
               });
               VueCookie.set("cid", res.id_customer, {
                  expires: res.token_expiry,
               });
               http.defaults.headers.common["Authorization"] = "Bearer " + res.token;
               VueCookie.set("user", JSON.stringify(res), {
                  expires: res.token_expiry,
               });

               const r = this.$router.resolve({
                  name: "Dashboard",
                });
                window.location.assign(r.href)
               
            })
            .catch((err) => {
               loader.hide();
               this.toast.error(err.response.statusText);
               this.toast.error("Incorrect Email or Password.");
               if (err.response.status == 403) {
                  this.userDeactivated = true;
               } else {
                  this.incorrectCredentials = true;
               }
               console.log(err);
            });
      },
   },
});
